module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/offsidebar/offsidebar.component.scss
// module id = ./src/app/layout/offsidebar/offsidebar.component.scss
// module chunks = main